import Link from 'next/link';
import { Layout, CtaForm } from '../../components';
import { BUILDING_TYPES } from '../../data/building_types';
import { omitKeyObject } from '../../utils';
import { ASSET_BASE_URL } from '../../constants';

export default function BuildingType({ buildingType }) {
	const {
		heading: { title, description },
		articles,
		plan,
		footer,
	} = buildingType;

	return (
		<Layout pageName={title}>
			<div className="building-type">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">{title}</h1>
							<h2 className="heading__desc">{description}</h2>
						</div>
					</div>
				</section>

				<section className="building-type__articles">
					<div className="container">
						<div className="building-type__articles-wrapper">
							{articles.map(({ title, description, image }, index) => {
								return (
									<article key={index} className="building-type__article">
										<img
											src={`${ASSET_BASE_URL}/images/building-types/commercial_${image}.webp`}
											alt=""
											className="building-type__article-img"
										/>

										<div className="building-type__article-content">
											<h3 className="building-type__article-title">{title}</h3>
											<div className="building-type__article-desc">{description}</div>
										</div>
									</article>
								);
							})}
						</div>
					</div>
				</section>

				<div className="pricing-wrapper">
					<div className="container">
						<h2 className="pricing-wrapper__title">{plan}</h2>

						<button className="btn btn--plans">
							<Link href="/pricing-plans">view plans and pricing</Link>
						</button>
					</div>
				</div>

				<CtaForm title={footer} />
			</div>
		</Layout>
	);
}

export async function getStaticProps({ params }) {
	try {
		const buildingType = BUILDING_TYPES.map((item) => omitKeyObject('submenu', item)).find(
			({ slug }) => slug == params.slug,
		);

		return {
			props: {
				buildingType,
			},
		};
	} catch (err) {
		console.log('🚀 ~ file: [slug].js ~ line 77 ~ getStaticProps ~ err', err);
		return {
			notFound: true,
		};
	}
}

export async function getStaticPaths() {
	const paths = BUILDING_TYPES.map((buildingType) => omitKeyObject('submenu', buildingType)).map(
		({ slug }) => `/building-types/${slug}`,
	);

	return {
		paths,
		fallback: false,
	};
}
